import React, {useContext, useState} from 'react';
import { useTheme, makeStyles, MenuItem } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import Helpers from '../../global/helpers';

import Quickcrumbs from '../../global/Quickcrumbs';
import SearchBar from '../../../components/searchBar';
import AutoTable from '../../../components/autoTable';
import globalContext from '../../../context/global-context';
import ActionMenu from '../../../components/actionMenu';
import EVConnectAppUserPasswordReset from './app_user/app_user_password_reset';
import EVConnectAppUser from './app_user';

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        width: '100%',
        height: '100%',
        flexDirection: 'column',
        overflow: 'auto'
    },
    inner: {
        flex: 1,
        padding: 20,
        flexDirection: 'row'
    },
    taskbar: {
        paddingTop: 20,
        paddingBottom: 20,
        display: 'flex',
        width: '100%',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
}));

const EVConnectAppUsers = props => {
    const theme = useTheme();
    const classes = useStyles(theme);
    const context = useContext(globalContext);

    
    const headCells = ["id_user","username","first_name","last_name","email","company_name","registered_on", "action"]
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const [passwordResetUser, setPasswordResetUser] = useState(null);
    const [user, setUser] = useState(null);

    const loadData = async search => {
        setLoading(true);
        setError(null);
        setData([]);

        try {
            
            const res = await context.apiRequest(`/service_consumer/ev_connect/app_users?search=${search}`, 'GET');
            if(res.success){
                setData(res.result);

                if(res.result.length >= 100)
                    setError('You search returned over 100 results, try refining your search criteria');
            }
            
        } catch (err) {

            setError(typeof err === 'string' ? err : typeof err?.msg === 'string' ? err.msg : JSON.stringify(err));
            setData([]);
            
        } finally {
            setLoading(false);
        }
        
    }

    const itemMenu = (val, id) => {

        console.log(id);
        const user = data.find(u => u.id_user === id);

        return(
            <ActionMenu>
                <MenuItem onClick={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    setPasswordResetUser(user)
                }}>Send Password Reset</MenuItem>
            </ActionMenu>
        )

    }


    return (
        <React.Fragment>
            <div className={classes.container}>
                <div className={classes.inner}>

                    <Quickcrumbs 
                        crumbs={[
                            {
                                name: 'Service Users',
                                route: '/service_users'
                            },
                            {
                                name: 'EV Connect App Users',
                                route: '/service_users/ev_connect/app_users'
                            }
                        ]}
                        history={props.history}
                    />

                    <div className={classes.taskbar}>
                        <SearchBar 
                            label="Search by name, email, company name or username" 
                            onSearch={loadData} 
                            onClear={() => setData([])}
                            shrink={false}
                         />
                    </div>

                    {error && <Alert severity="error">{error}</Alert>}

                    <AutoTable 
                        rows={data} 
                        idCol="id_user"
                        headCells={headCells}
                        loading={loading}
                        handleRowClick={setUser}
                        cellReplacementProps={{
                            'registered_on': (val, id) => Helpers.toLocaleDateTime(val),
                            'action': (val, id) => itemMenu(val, id)
                        }}
                    />

                </div>
            </div>

            {passwordResetUser !== null && <EVConnectAppUserPasswordReset user={passwordResetUser} handleClose={() => setPasswordResetUser(null)} />}
            {user !== null && <EVConnectAppUser user={user} handleClose={() => setUser(null)} />}
        </React.Fragment>
    )
}
export default EVConnectAppUsers;